module.exports = __webpack_public_path__ + "img/img_zi2@2x.7de28e61.png";